import { serviceRequest } from './service-request';
import type { Conversation } from '@cognitoforms/types/server-types/model/conversation';
import type { ChatHistoryViewModel } from '@cognitoforms/types/server-types/core/services/forms/a-i/chat-history-view-model';

export function getAllConversations(conversationType: string, top: number = null): Promise<Conversation[]> {
	return serviceRequest(`svc/conversations/${encodeURIComponent(conversationType)}`, { top }, {
		method: 'GET'
	});
}

export function getConversation(conversationType: string, conversationId: string): Promise<ChatHistoryViewModel[]> {
	return serviceRequest(`svc/conversations/${encodeURIComponent(conversationType)}/${encodeURIComponent(conversationId)}`, {}, {
		method: 'GET'
	});
}

export function submitFeedback(conversationType: string, conversationId: string, feedback: boolean | null): Promise<ChatHistoryViewModel> {
	return serviceRequest(`svc/conversations/${encodeURIComponent(conversationType)}/${encodeURIComponent(conversationId)}/feedback`, {
		feedback
	}, {
		method: 'POST'
	});
}

export function deleteConversation(conversationType: string, conversationId: string): Promise<void> {
	return serviceRequest(`svc/conversations/${encodeURIComponent(conversationType)}/${encodeURIComponent(conversationId)}`, {}, {
		method: 'DELETE'
	});
}

export function renameConversation(conversationType: string, conversationId: string, newName: string): Promise<void> {
	return serviceRequest(`svc/conversations/${encodeURIComponent(conversationType)}/${encodeURIComponent(conversationId)}/rename`, { newName }, {
		method: 'POST'
	});
}